import { AuthContextProvider, BaseApiClient, ServiceEnvironment } from '@streamelements/client-sdk-js';

export class TiktokKVStoreApiClient extends BaseApiClient {
  constructor({
    authContextProvider,
    serviceEnvironment,
  }: {
    authContextProvider: AuthContextProvider;
    serviceEnvironment: ServiceEnvironment;
  }) {
    super({
      authContextProvider,
      baseURL: `${serviceEnvironment.keyValueStoreV1ApiBaseUrl}/{channel_id}/`,
    });
  }

  async fetchApprovalStatus({
    providerId,
  }: {
    providerId: string;
  }): Promise<{ providerId: string; isApproved: boolean }> {
    return this.get<void, { value: boolean }>(`tiktok.approval.${providerId}`).then(({ value }) => ({
      providerId,
      isApproved: value,
    }));
  }

  async setApprovalStatus({ providerId, status }: { providerId: string; status: boolean }): Promise<void> {
    await this.put('', {
      key: `tiktok.approval.${providerId}`,
      value: status,
    });
  }
}
